import { NgIf } from '@angular/common';
import { Component, Input, OnChanges } from '@angular/core';
import {
	AiSummarySourceBarComponent,
	SourceBarItem
} from '@brand-lolly/app/social-media-influencer/modules/social-listening/pages/ai-summary/components/ai-summary-source-bar.component';

const MENTION_COLORS = ['#2872e1', '#7aa8ee', '#b4ccf4', '#d9e4f8', '#c8c8d0'];
const REVIEW_COLORS = ['#16a34a', '#5fbf7f', '#a1d8b0', '#d5eedc', '#c8c8d0'];

interface SourceItem {
	platform: string;
	count: number;
	percentage: number;
}

@Component({
	standalone: true,
	selector: 'app-ai-summary-sources',
	imports: [NgIf, AiSummarySourceBarComponent],
	templateUrl: './ai-summary-sources.component.html',
	styleUrls: ['./ai-summary-sources.component.scss']
})
export class AiSummarySourcesComponent implements OnChanges {
	@Input() channels: SourceItem[] = [];
	@Input() reviewSources: SourceItem[] = [];

	channelItems: SourceBarItem[] = [];
	reviewItems: SourceBarItem[] = [];

	ngOnChanges(): void {
		this.channelItems = this.toBarItems(this.channels, MENTION_COLORS);
		this.reviewItems = this.toBarItems(this.reviewSources, REVIEW_COLORS);
	}

	private toBarItems(items: SourceItem[], colors: string[]): SourceBarItem[] {
		return items.map((item, i) => ({
			label: item.platform,
			color: colors[i] ?? colors[colors.length - 1],
			percentage: item.percentage
		}));
	}
}
